module.exports = __webpack_public_path__ + "static/img/platform-3.373f5a37.png";